import { ReactNode, useContext } from "react";
import { ThemeValues } from "../ThemeUsage/theme";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { Typography, TypographyProps, styled } from "@mui/material";

interface PageTitleProps extends TypographyProps {
  text: string | ReactNode;
}

const PageTitleStyles = styled(Typography)(({ theme }) => ({
  color: theme.palette.app.primaryFont,
  fontSize: "32px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "35px",
  whiteSpace: "pre-line",
}));

const PageTitle = ({ text, ...props }: PageTitleProps) => {
  const themeName = useContext(ThemeContext);
  const titleFontFamily =
    themeName === ThemeValues.lichtblick ? "officina" : "isonType";

  return (
    <PageTitleStyles variant="h1" {...props} fontFamily={titleFontFamily}>
      {text}
    </PageTitleStyles>
  );
};

export default PageTitle;
